<template>
  <div class="my-layout-box dashboard">
    <div class="swipe">
      <div class="swipe-item item1"></div>
    </div>
    <div class="message">
      <div style="display:flex;justify-content: space-between;">
        <p><b>{{ user.ClientName }}</b></p>
        <p @click="() => { show = !show }" v-if="clientList.length > 0" style="color: #1989fa;"><b>切换账户</b></p>
      </div>
      <ul class="p-dashboard-message-ul">
        <li>
          <span>订单总数</span>
          <i style="color: green">{{ orderNumber.TotalCount }}</i>
        </li>
        <li>
          <span>未提交订单</span>
          <i style="color: rgb(34, 136, 204)">{{ orderNumber.WaitCommitCount }}</i>
        </li>
        <li>
          <span>待审核订单</span>
          <i style="color: #ff6034">{{ orderNumber.WaitAuditCount }}</i>
        </li>
        <li>
          <span>已审核订单</span>
          <i style="color: #ca711c">{{ orderNumber.AuditedCount }}</i>
        </li>
      </ul>
    </div>
    <div class="modules">
      <div class="module-item-group">
        <div class="module-item" v-for="(item, index) in homeOneData" :key="index" @click="onClick(item)">
          <i :class="item.className"></i>
          <div class="module-item-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="module-item-group">
        <div class="module-item" v-for="(item, index) in homeTwoData" :key="index" @click="onClick(item)">
          <svg-icon v-if="item.svg" :icon-class="item.svg" />
          <i v-else :class="item.className"></i>
          <div class="module-item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="rate">
      <div class="rate-row">
        <div class="header">今日付汇汇率</div>
        <div class="rate-item-group">
          <div class="rate-item" v-for="rate in orderRates" :key="rate.title">
            <div :class="rate.status == 'up' ? 'rate-item-value-up' : 'rate-item-value-down'">
              {{ rate.value }}
            </div>
            <div class="rate-item-title">{{ rate.title }}</div>
            <div v-if="rate.status == 'up'" class="rate-item-icon">
              <i class="iconfont icon-rise_ic"></i>
            </div>
            <div v-if="rate.status == 'down'" class="rate-item-icon">
              <i class="iconfont icon-decline_ic"></i>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="rate-row">
        <div class="header">本月海关汇率</div>
        <div class="rate-item-group">
          <div class="rate-item" v-for="rate in customsRates" :key="rate.title">
            <div :class="rate.status == 'up' ? 'rate-item-value-up' : 'rate-item-value-down'">
              {{ rate.value }}
            </div>
            <div class="rate-item-title">{{ rate.title }}</div>
            <div v-if="rate.status == 'up'" class="rate-item-icon">
              <i class="iconfont icon-rise_ic"></i>
            </div>
            <div v-if="rate.status == 'down'" class="rate-item-icon">
              <i class="iconfont icon-decline_ic"></i>
            </div>
          </div>
        </div>
      </div>
      -->
    </div>
    <section class="c-box p-remind">
      <p class="p-remind-header">
        <span>最新动态: </span>
      </p>
      <!-- <ul class="c-content-ul">
        <li>
          <span>订单号: </span>
          <i>A000729</i>
        </li>
      </ul> -->
      <ul class="c-content-ul">
        <li>
          <span></span>
          <i>{{ message.content }}</i>
        </li>
      </ul>
      <p class="p-more" @click="onMoreMessage">
        <span>更多</span>
        <i class="iconfont icon-gengduo"></i>
      </p>
    </section>

    <van-popup v-model="show" :style="{ height: '50%', width: '100%' }" position="bottom">
      <div style="position:relative;height:100%">
        <van-cell-group>
          <van-cell>
            <template #title>
              <span class="custom-title">{{ user.ClientName }}</span>
              <div class="client-select">
                <span>当前账户</span>
              </div>
            </template>
          </van-cell>
          <van-cell v-for="(v, i) in clientList" :key="i">
            <template #title>
              <span class="custom-title">{{ v.ClientName }}</span>

              <div class="client-select">
                <span class="c-no-sel" @click="ChangeClient(v)">切换</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        <div class="cancle-sel">
          <van-button type="primary" size="small" color="#1989fa" style="width:60%">取消</van-button>
        </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { orderRates, customsRates, homeOneData, homeTwoData } from "./data";
import {
  getOrderNumber,
  getRate,
  getCustomsRate,
  getMesSenc,
  GetSwitchClientList,
  SwitchClient
} from "~/api/home";

export default {
  name: "Dashboard",

  computed: {
    ...mapGetters(["user"]),
  },

  data() {
    return {
      orderRates: [...orderRates],
      customsRates: [...customsRates],
      homeOneData: [...homeOneData],
      homeTwoData: [...homeTwoData],
      orderNumber: {
        AuditedCount: null,
        TotalCount: null,
        WaitAuditCount: null,
        WaitCommitCount: null,
      },
      message: {
        sendTime: "",
        content: "",
      },
      clientList: [],
      show: false,
    };
  },

  methods: {
    onClick(item) {
      const routeName = item.routeName;
      this.$router.push({
        name: routeName,
      });
    },
    async getRate() {
      const data = await getRate();

      this.orderRates.forEach((item) => {
        item["value"] = data[item.currency];
        item["status"] = data[item.statusStr];
      });
    },
    async getOrderNumber() {
      const data = await getOrderNumber();
      Object.keys(this.orderNumber).forEach((key) => {
        this.orderNumber[key] = data[key];
      });
    },
    async getCustomsRate() {
      const data = await getCustomsRate();
      this.customsRates.forEach((item) => {
        item["value"] = data[item.currency];
        item["status"] = data[item.statusStr];
      });
    },

    onMoreMessage() {
      this.$router.push({
        name: "message",
      });
    },
    async onGetMesSenc() {
      const data = await getMesSenc();
      if (data) {
        this.message.sendTime = data.SendTime;
        this.message.content = data.Content;
      }
    },

    async getOtherClient() {
      let data = await GetSwitchClientList();
      this.clientList = data.filter((x) => {
        return x.ClientName != this.user.ClientName;
      });
    },

    async ChangeClient(client) {
      const sendData = {
        clientId: client.ClientId,
      };
      await SwitchClient(sendData);
      window.location.reload()
    },
  },
  created() {
    this.getRate();
    this.getOrderNumber();
    this.getCustomsRate();
    this.onGetMesSenc();
    this.getOtherClient();
  },

  mounted() {
    this.getOtherClient();
  }
};
</script>

<style lang="less" scoped>
.dashboard {
  position: relative;

  .swipe {
    .swipe-item {
      height: 1rem;
      // &.item1 {
      //   background: url("~images/dashboard/swipe/bg1.jpeg") no-repeat center center;
      // }

      &.item1 {
        background: #ffad00;
      }
    }
  }

  .message {
    position: absolute;
    padding: 15px;
    width: 94%;
    height: 1rem;
    background: #fff;
    margin: 0 auto;
    top: 0.5rem;
    left: 48%;
    margin-left: -45%;
    border-radius: 2px;
    box-shadow: -1px 1px 5px #c7c1c1;

    p:nth-child(1) {
      font-size: 0.14rem;
    }
  }

  .p-dashboard-message-ul {
    display: flex;
    margin-top: 0.12rem;

    li {
      text-align: center;
      flex: 0.25;
    }

    i {
      font-style: normal;
      font-size: 0.14rem;
    }

    span {
      font-size: 0.13rem;
      display: block;
      margin-bottom: 5px;
      color: #888787;
    }
  }

  .modules {
    padding: 0.8rem 15px 15px 15px;
    border-bottom: 1px solid #ddd;
    background: #fff;

    .module-item-group {
      display: flex;
      //justify-content: space-between;
      margin-top: 0;


      &+.module-item-group {
        margin-top: 10px;
      }
    }

    .module-item {
      flex: 1/3;
      text-align: center;
      width: 33%;
    }

    .module-item-icons {
      height: 42px;
      width: 42px;
      display: inline-block;
      background-position: center center;
      background-size: cover;
    }

    .module-item-title {
      font-size: 0.14rem;
      margin-top: 5px;
    }

    .svg-icon {
      width: 25px;
      height: 25px;
    }
  }

  .rate {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;

    .rate-row {
      margin-top: 10px;

      .header {
        text-align: left;
        font-size: 0.14rem;
        font-weight: normal;
      }
    }

    .rate-item-group {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;

      .rate-item {
        font-size: 12px;
        border: 1px solid #ddd;
        padding: 6px;
        text-align: center;
        flex: 0.23;
        position: relative;
      }

      .rate-item-icon {
        position: absolute;
        top: 20%;
        right: 2%;
        font-size: 0.18rem;

        .icon-rise_ic {
          color: red;
        }

        .icon-decline_ic {
          color: green;
        }
      }

      .rate-item-value-up {
        color: red;
      }

      .rate-item-value-down {
        color: green;
      }
    }
  }

  .p-remind {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;

    .p-more {
      text-align: right;
      color: skyblue;
      cursor: pointer;
    }

    .p-remind-header {
      font-size: 0.14rem;
      margin-bottom: 5px;
    }
  }

  .van-cell {
    font-size: 0.12rem;
    justify-content: space-between;
    position: relative;
  }

  .client-select {
    position: absolute;
    right: 0.12rem;
    top: 0.12rem;
    text-align: center;
    width: 0.7rem;

    .c-no-sel {
      color: #1989fa;
    }
  }

  .cancle-sel {
    position: absolute;
    bottom: 0.1rem;
    text-align: center;
    width: 100%;
  }
}
</style>
